import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import firebase from 'firebase';


@Injectable()
export class FirebaseData {
	public realtimeDb: any;

	constructor(){    	
		this.realtimeDb = firebase.database(); 
  }

  public get(childRef) {
  	return Observable.create((observer) => {
  		this.realtimeDb.ref('/').child(childRef).once('value', data => {
  			observer.next(data.val());
  		});
  	});    	
	}

	public getTop(childRef, numofRecords, orderBy=null) {
  	return Observable.create((observer) => {
  		if(orderBy == null || orderBy==''){
  			this.realtimeDb.ref(childRef).orderByKey().limitToFirst(numofRecords).on('value', data => {
    			observer.next(data.val());
    		});
  		} else {
    		this.realtimeDb.ref(childRef).orderByChild(orderBy).limitToFirst(numofRecords).on('value', data => {
    			observer.next(data.val());
    		});
    	}
  	});    	
	}  	

	public getLast(childRef, numofRecords, orderBy=null) {
  	return Observable.create((observer) => {
  		if(orderBy == null || orderBy==''){
  			this.realtimeDb.ref(childRef).orderByKey().limitToLast(numofRecords).on('value', data => {
    			observer.next(data.val());
    		});
  		} else {
    		this.realtimeDb.ref(childRef).orderByChild(orderBy).limitToLast(numofRecords).on('value', data => {
    			observer.next(data.val());
    		});
    	}
  	});    	
	}

  public getByUserId(childRef, uid) {
    return Observable.create((observer) => {
      this.realtimeDb.ref('/').child(childRef).child(uid).on('value', data => {
        observer.next(data.val());
      });
    });      
  }
  
  public set(childRef, obj){
    return new Promise((resolve, reject) => {
      this.realtimeDb.ref(childRef).set(obj).then(error => {
        if(error) {
          reject(error);
        } else {
          resolve("SET_SUCCESS");
        }
      });
    });
  }

  public remove(childRef){
    return new Promise((resolve, reject) => {
      this.realtimeDb.ref(childRef).remove().then(error => {
        if(error) {
          reject(error);
        } else {
          resolve("REMOVE_SUCCESS");
        }
      });
    });
  }

  public setUserData(uid, userData){
    return Observable.create((observer)=>{
      var timeStamp = (<any>firebase.database).ServerValue.TIMESTAMP;
      userData.timestampCreated = timeStamp;
      userData.timestampModified = timeStamp;

      var updates = {};
      updates['/users/' + uid ] = userData;
      this.realtimeDb.ref().update(updates).then(function(){
        observer.next(true);
      }, function(error){
        observer.next(false);
      });
    });
  }

  public setMembershipEmployee(user){
    return new Promise((resolve, reject) => {
      this.realtimeDb.ref('membership-employee/' + user.employeeId).set({
        email: user.email
      }).then(error => {
        if(error) {
          reject(error);
        } else {
          resolve("SET_SUCCESS");
        }
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/providers/firebase-data.ts